import {
  BackupLogRepository,
  BackupRepoRepository,
  BackupRepository,
  BackupScheduleRepository,
  BackupServerRepository,
  BackupTaskRepository,
  ConfigResetRepository,
  ForgetServerRepository,
  RepoLocksRepository,
  RestoreTaskRepository, TaskRepository, TaskScheduleRepository,
} from '@/services/Backup';
import type {
  BackupLogRepositoryInterface,
  BackupRepoRepositoryInterface,
  BackupRepositoryInterface,
  BackupScheduleRepositoryInterface,
  BackupServerRepositoryInterface,
  BackupTaskRepositoryInterface,
  ConfigResetRepositoryInterface,
  ForgetServerRepositoryInterface,
  RepoLocksRepositoryInterface,
  RestoreTaskRepositoryInterface, TaskRepositoryInterface, TaskScheduleRepositoryInterface,
} from '@/services/Backup/interfaces';

import ActionLogRepository from './Action-Logs';
import { ActionLogRepositoryInterface } from './Action-Logs/interfaces';
import AuthRepository from '@/services/Auth';
import { AxiosInstance } from 'axios';
import BugCommentRepository from '@/services/Bug-report/Bug-report/Comments';
import BugCommentRepositoryInterface from '@/services/Bug-report/Bug-report/Comments/interfaces';
import BugDepartmentRepository from '@/services/Bug-report/Bug-report/Departments';
import BugDepartmentRepositoryInterface from '@/services/Bug-report/Bug-report/Departments/interfaces';
import BugFolderRepository from '@/services/Bug-report/Bug-report/Folders';
import BugFolderRepositoryInterface from '@/services/Bug-report/Bug-report/Folders/interfaces';
import BugNoteRepository from '@/services/Bug-report/Bug-report/Notes';
import BugReportRepository from '@/services/Bug-report/Bug-report';
import BugReportRepositoryInterface from '@/services/Bug-report/Bug-report/interfaces';
import { CDNVhostRepository } from '@/services/Vhost/CDN';
import CDNVhostRepositoryInterface from 'src/services/Vhost/CDN/Interfaces';
import CertificateRepository from '@/services/SSL';
import { CertificatesRepositoryInterface } from '@/services/SSL/interfaces';
import ChatRepository from '@/services/QA/chat';
import ChatRepositoryInterface from '@/services/QA/chat/interfaces';
import { ChatRepositoryInterface as ChatRepositoryInterfaceV2 } from '@/services/QC-V2/chat/interfaces';
import { default as ChatRepositoryV2 } from '@/services/QC-V2/chat';
import CommentRepository from '@/services/QA/comment';
import CommentRepositoryInterface from '@/services/QA/comment/interfaces';
import { CommentRepositoryInterface as CommentRepositoryInterfaceV2 } from '@/services/QC-V2/comment/interfaces';
import { default as CommentRepositoryV2 } from '@/services/QC-V2/comment';
import ComponentRepository from '@/services/Bug-report/Settings/repos/ComponentRepository';
import CronSettingsRepository from '@/services/QA/cron-settings';
import { CronSettingsRepositoryInterface } from '@/services/QA/cron-settings/interfaces';
import DNSRepository from '@/services/DNS';
import DNSRepositoryInterface from '@/services/DNS/Interfaces';
import DnsCheckerRepository, { DnsCheckerRepositoryInterface } from '@/services/DnsChecker';
import DatabaseRepository from '@/services/Database';
import { DatabaseRepositoryInterface } from '@/services/Database/interfaces';
import DepartmentRepository from '@/services/Departments';
import DepartmentRepositoryInterface from '@/services/Departments/Interfaces';
import DevScrumRepository from '@/services/Dev-scrum';
import DossierFeedbackRepository from '@/services/Dossier/feedback';
import DossierFeedbackRepositoryInterface from '@/services/Dossier/feedback/interfaces';
import DossierFeedbackReviewRepository from '@/services/Dossier/review';
import DossierFeedbackReviewRepositoryInterface from '@/services/Dossier/review/interfaces';
import DossierMembershipRepository from '@/services/Dossier/membership';
import DossierMembershipRepositoryInterface from '@/services/Dossier/membership/interfaces';
import DossierPositionRepository from '@/services/Dossier/position';
import DossierPositionRepositoryInterface from '@/services/Dossier/position/interfaces';
import DossierTeamRepository from '@/services/Dossier/team';
import DossierTeamRepositoryInterface from '@/services/Dossier/team/interfaces';
import DossierUserRepository from '@/services/Dossier/user';
import DossierUserRepositoryInterface from '@/services/Dossier/user/interfaces';
import EmployeeBirthdaysRepository from '@/services/Calendar/EmployeeBirthdays';
import EmployeeBirthdaysRepositoryInterface from '@/services/Calendar/EmployeeBirthdays/Interfaces';
import EscalationRepository from '@/services/QA/escalation';
import { EscalationRepositoryInterface } from '@/services/QA/escalation/interfaces';
import {
  EscalationRepositoryInterface as EscalationRepositoryInterfaceV2,
} from '@/services/QC-V2/escalation/interfaces';
import { default as EscalationRepositoryV2 } from '@/services/QC-V2/escalation';
import EventAttendanceRepository from '@/services/Calendar/EventAttendance';
import EventAttendanceRepositoryInterface from '@/services/Calendar/EventAttendance/Interfaces';
import EventAttendantRepository from '@/services/Calendar/EventAttendant';
import EventAttendantRepositoryInterface from '@/services/Calendar/EventAttendant/Interfaces';
import EventsRepository from '@/services/Calendar/Events';
import EventsRepositoryInterface from '@/services/Calendar/Events/Interfaces';
import FeatureCommentRepository from '@/services/Bug-report/Feature-request/Comments';
import FeatureCommentRepositoryInterface from '@/services/Bug-report/Feature-request/Comments/interfaces';
import FeatureNoteRepository from '@/services/Bug-report/Feature-request/Notes';
import FeatureNoteRepositoryInterface from '@/services/Bug-report/Feature-request/Notes/interfaces';
import FeatureRequestRepository from '@/services/Bug-report/Feature-request/Feature-request';
import FeatureRequestRepositoryInterface from '@/services/Bug-report/Feature-request/Feature-request/interfaces';
import FeedbackRepository from '@/services/QA/feedback';
import FeedbackRepositoryInterface from '@/services/QA/feedback/interfaces';
import { FeedbackRepositoryInterface as FeedbackRepositoryInterfaceV2 } from '@/services/QC-V2/feedback/interfaces';
import { default as FeedbackRepositoryV2 } from '@/services/QC-V2/feedback';
import FileRepository from '@/services/File-manager/file';
import FileRepositoryInterface from '@/services/File-manager/interfaces/file.interface';
import FolderRepository from '@/services/File-manager/folder';
import FolderRepositoryInterface from '@/services/File-manager/interfaces/folder.interface';
import FtpUserRepository from './FtpUser';
import { FtpUserRepositoryInterface } from './FtpUser/interfaces';
import IPSetRepository from '@/services/IPSet';
import IPSetRepositoryInterface from '@/services/IPSet/Interfaces';
import InternalTicketsRepository from '@/services/Internal-Tickets';
import InternalTicketsRepositoryInterface from '@/services/Internal-Tickets/interfaces';
import { LeavesRepository } from '@/services/Calendar/leaves';
import { LeavesRepositoryInterface } from '@/services/Calendar/leaves/interfaces';
import MailboxRepository from '@/services/Mailbox';
import { MailboxRepositoryInterface } from '@/services/Mailbox/interfaces';
import NationalEventsRepository from '@/services/Calendar/NationalEvents';
import NationalEventsRepositoryInterface from '@/services/Calendar/NationalEvents/Interfaces';
import NoteRepository from '@/services/QA/note';
import NoteRepositoryInterface from '@/services/QA/note/interfaces';
import { NoteRepositoryInterface as NoteRepositoryInterfaceV2 } from '@/services/QC-V2/note/interfaces';
import { default as NoteRepositoryV2 } from '@/services/QC-V2/note';
import OriginVhostRepository from '@/services/Vhost/Origin';
import OriginVhostRepositoryInterface from 'src/services/Vhost/Origin/Interfaces';
import PriorityRepository from '@/services/Bug-report/Settings/repos/PriorityRepository';
import PriorityRepositoryInterface from '@/services/Bug-report/Settings/interfaces/priority.repository';
import ProfileRepository from '@/services/Users-profile';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import RepeatableEventsRepository from '@/services/Calendar/RepeatableEvents';
import RepeatableEventsRepositoryInterface from '@/services/Calendar/RepeatableEvents/Interfaces';
import RoleRepository from '@/services/Roles';
import RoleRepositoryInterface from '@/services/Roles/Interfaces';
import SMSRepository from '@/services/SMS';
import SMSRepositoryInterface from '@/services/SMS/interfaces';
import ScopesRepository from '@/services/Scopes';
import ScopesRepositoryInterface from '@/services/Scopes/Interfaces';
import ScoreGradeRepository from '@/services/QA/scoreGrade';
import ScoreGradeRepositoryInterface from '@/services/QA/scoreGrade/interfaces';
import {
  ScoreGradeRepositoryInterface as ScoreGradeRepositoryInterfaceV2,
} from '@/services/QC-V2/score-grade/interfaces';
import { default as ScoreGradeRepositoryV2 } from '@/services/QC-V2/score-grade';
import ScoreTypeRepository from '@/services/QA/scoreType';
import ScoreTypeRepositoryInterface from '@/services/QA/scoreType/interfaces';
import { ScoreTypeRepositoryInterface as ScoreTypeRepositoryInterfaceV2 } from '@/services/QC-V2/score-type/interfaces';
import { default as ScoreTypeRepositoryV2 } from '@/services/QC-V2/score-type';
import ServerRepository from '@/services/Server';
import { ServerRepositoryInterface } from '@/services/Server/Interfaces';
import ShiftAutomationRepository from '@/services/Calendar/ShiftAutomation';
import ShiftAutomationRepositoryInterface from '@/services/Calendar/ShiftAutomation/Interfaces';
import ShiftNoteRepository from '@/services/Calendar/ShiftNote';
import ShiftNoteRepositoryInterface from '@/services/Calendar/ShiftNote/Interfaces';
import ShiftRepository from '@/services/Calendar/Shifts';
import ShiftRepositoryInterface from '@/services/Calendar/Shifts/Interfaces';
import ShiftTeamRepository from '@/services/Calendar/ShiftTeam';
import ShiftTeamRepositoryInterface from '@/services/Calendar/ShiftTeam/Interfaces';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';
import ShiftTypeRepositoryInterface from '@/services/Calendar/ShiftType/Interfaces';
import { StatisticRepositoryInterface as StatisticRepositoryInterfaceV2 } from '@/services/QC-V2/statistic/interfaces';
import { default as StatisticRepositoryV2 } from '@/services/QC-V2/statistic';
import StatisticsRepository from '@/services/QA/statistics';
import { StatisticsRepositoryInterface } from '@/services/QA/statistics/interfaces';
import StatusRepository from '@/services/Bug-report/Settings/repos/StatusRepository';
import StatusRepositoryInterface from '@/services/Bug-report/Settings/interfaces/status.repository';
import SystemUserRepository from '@/services/SystemUsers';
import { SystemUserRepositoryInterface } from '@/services/SystemUsers/interfaces';
import TagRepository from '@/services/QA/tag';
import TagRepositoryInterface from '@/services/QA/tag/interfaces';
import { TagRepositoryInterface as TagRepositoryInterfaceV2 } from '@/services/QC-V2/tag/interfaces';
import { default as TagRepositoryV2 } from '@/services/QC-V2/tag';
import TicketRepository from '@/services/QA/ticket';
import TicketRepositoryInterface from '@/services/QA/ticket/interfaces';
import { default as TicketRepositoryInterfaceV2 } from '@/services/QC-V2/ticket/interfaces';
import { default as TicketRepositoryV2 } from '@/services/QC-V2/ticket';
import { UserRepoInterface } from '@/services/Users/Interfaces';
import UsersRepo from './Users';
import WPCliRepository from '@/services/WPCli';
import WPCliRepositoryInterface from '@/services/WPCli/interfaces';
import WebsiteGroupRepository from './WebsiteGroup';
import WebsiteGroupRepositoryInterface from './WebsiteGroup/interfaces';
import WebsiteLogRepository from '@/services/WebsiteLog';
import WebsiteLogRepositoryInterface from '@/services/WebsiteLog/interfaces';
import WebsiteRepository from '@/services/Website';
import WebsiteRepositoryInterface from '@/services/Website/interfaces';
import WebsiteStagingRepository from '@/services/WebsiteStaging';
import WebsiteStagingRepositoryInterface from '@/services/WebsiteStaging/interfaces';
import RedisCacheRepositoryInterface from '@/services/RedisCache/interfaces/redis-cache.interface';
import RedisCacheRepository from '@/services/RedisCache';
import WebsiteMigrationsRepository from '@/services/WebsiteMigrations';
import WebsiteMigrationsRepositoryInterface from '@/services/WebsiteMigrations/interfaces';
import PlanRepository from '@/services/Plan';
import { PlanRepositoryInterface } from '@/services/Plan/interfaces';
import { UsageRepositoryInterface } from "@/services/Usage/interfaces";
import UsageRepository from "@/services/Usage";

export default function (axios: AxiosInstance): any {
  return {
    get authRepository(): AuthRepository {
      return new AuthRepository(axios);
    },

    get userRepository(): UserRepoInterface {
      return new UsersRepo(axios);
    },

    get scopesRepository(): ScopesRepositoryInterface {
      return new ScopesRepository(axios);
    },

    get rolesRepository(): RoleRepositoryInterface {
      return new RoleRepository(axios);
    },
    get devScrumRepository(): DevScrumRepository {
      return new DevScrumRepository(axios);
    },


    get ipsetRepository(): IPSetRepositoryInterface {
      return new IPSetRepository(axios);
    },

    get cdnVhostRepository(): CDNVhostRepositoryInterface {
      return new CDNVhostRepository(axios);
    },

    get originVhostRepository(): OriginVhostRepositoryInterface {
      return new OriginVhostRepository(axios);
    },

    get serverRepository(): ServerRepositoryInterface {
      return new ServerRepository(axios);
    },

    get dnsRepository(): DNSRepositoryInterface {
      return new DNSRepository(axios);
    },

    get dnsCheckerRepository(): DnsCheckerRepositoryInterface {
      return new DnsCheckerRepository();
    },

    get certificateRepository(): CertificatesRepositoryInterface {
      return new CertificateRepository(axios);
    },

    get chatRepository(): ChatRepositoryInterface {
      return new ChatRepository(axios);
    },

    get tagRepository(): TagRepositoryInterface {
      return new TagRepository(axios);
    },

    get scoreTypeRepository(): ScoreTypeRepositoryInterface {
      return new ScoreTypeRepository(axios);
    },

    get scoreGradeRepository(): ScoreGradeRepositoryInterface {
      return new ScoreGradeRepository(axios);
    },
    get commentRepository(): CommentRepositoryInterface {
      return new CommentRepository(axios);
    },
    get noteRepository(): NoteRepositoryInterface {
      return new NoteRepository(axios);
    },
    get escalationRepository(): EscalationRepositoryInterface {
      return new EscalationRepository(axios);
    },
    get feedbackRepository(): FeedbackRepositoryInterface {
      return new FeedbackRepository(axios);
    },
    get statisticRepository(): StatisticsRepositoryInterface {
      return new StatisticsRepository(axios);
    },
    get departmentRepository(): DepartmentRepositoryInterface {
      return new DepartmentRepository(axios);
    },
    get ticketRepository(): TicketRepositoryInterface {
      return new TicketRepository(axios);
    },
    get cronSettingsRepository(): CronSettingsRepositoryInterface {
      return new CronSettingsRepository(axios);
    },
    get shiftRepository(): ShiftRepositoryInterface {
      return new ShiftRepository(axios);
    },
    get shiftNoteRepository(): ShiftNoteRepositoryInterface {
      return new ShiftNoteRepository(axios);
    },
    get shiftTeamRepository(): ShiftTeamRepositoryInterface {
      return new ShiftTeamRepository(axios);
    },
    get shiftTypeRepository(): ShiftTypeRepositoryInterface {
      return new ShiftTypeRepository(axios);
    },
    get shiftAutomationRepository(): ShiftAutomationRepositoryInterface {
      return new ShiftAutomationRepository(axios);
    },
    get profileRepository(): ProfileRepositoryInterface {
      return new ProfileRepository(axios);
    },
    get nationalEventsRepository(): NationalEventsRepositoryInterface {
      return new NationalEventsRepository(axios);
    },
    get employeeBirthdaysRepository(): EmployeeBirthdaysRepositoryInterface {
      return new EmployeeBirthdaysRepository(axios);
    },
    get repeatableEventsRepository(): RepeatableEventsRepositoryInterface {
      return new RepeatableEventsRepository(axios);
    },
    get eventsRepository(): EventsRepositoryInterface {
      return new EventsRepository(axios);
    },
    get eventAttendanceRepository(): EventAttendanceRepositoryInterface {
      return new EventAttendanceRepository(axios);
    },
    get eventAttendantRepository(): EventAttendantRepositoryInterface {
      return new EventAttendantRepository(axios);
    },
    get leavesRepository(): LeavesRepositoryInterface {
      return new LeavesRepository(axios);
    },
    get bugReportRepository(): BugReportRepositoryInterface {
      return new BugReportRepository(axios);
    },
    get componentRepository(): ComponentRepository {
      return new ComponentRepository(axios);
    },
    get statusRepository(): StatusRepositoryInterface {
      return new StatusRepository(axios);
    },
    get priorityRepository(): PriorityRepositoryInterface {
      return new PriorityRepository(axios);
    },
    get bugCommentRepository(): BugCommentRepositoryInterface {
      return new BugCommentRepository(axios);
    },
    get bugNoteRepository(): BugNoteRepository {
      return new BugNoteRepository(axios);
    },
    get bugDepartmentRepository(): BugDepartmentRepositoryInterface {
      return new BugDepartmentRepository(axios);
    },
    get bugFolderRepository(): BugFolderRepositoryInterface {
      return new BugFolderRepository(axios);
    },
    get featureRequestRepository(): FeatureRequestRepositoryInterface {
      return new FeatureRequestRepository(axios);
    },
    get featureCommentRepository(): FeatureCommentRepositoryInterface {
      return new FeatureCommentRepository(axios);
    },
    get featureNoteRepository(): FeatureNoteRepositoryInterface {
      return new FeatureNoteRepository(axios);
    },
    get fileRepository(): FileRepositoryInterface {
      return new FileRepository(axios);
    },
    get folderRepository(): FolderRepositoryInterface {
      return new FolderRepository(axios);
    },
    get databaseRepository(): DatabaseRepositoryInterface {
      return new DatabaseRepository(axios);
    },
    get systemUserRepository(): SystemUserRepositoryInterface {
      return new SystemUserRepository(axios);
    },
    get chatRepositoryV2(): ChatRepositoryInterfaceV2 {
      return new ChatRepositoryV2(axios);
    },
    get scoreTypeRepositoryV2(): ScoreTypeRepositoryInterfaceV2 {
      return new ScoreTypeRepositoryV2(axios);
    },
    get scoreGradeRepositoryV2(): ScoreGradeRepositoryInterfaceV2 {
      return new ScoreGradeRepositoryV2(axios);
    },
    get tagRepositoryV2(): TagRepositoryInterfaceV2 {
      return new TagRepositoryV2(axios);
    },
    get commentRepositoryV2(): CommentRepositoryInterfaceV2 {
      return new CommentRepositoryV2(axios);
    },
    get noteRepositoryV2(): NoteRepositoryInterfaceV2 {
      return new NoteRepositoryV2(axios);
    },
    get feedbackRepositoryV2(): FeedbackRepositoryInterfaceV2 {
      return new FeedbackRepositoryV2(axios);
    },
    get escalationRepositoryV2(): EscalationRepositoryInterfaceV2 {
      return new EscalationRepositoryV2(axios);
    },
    get statisticRepositoryV2(): StatisticRepositoryInterfaceV2 {
      return new StatisticRepositoryV2(axios);
    },
    get dossierUserRepository(): DossierUserRepositoryInterface {
      return new DossierUserRepository(axios);
    },
    get dossierPositionRepository(): DossierPositionRepositoryInterface {
      return new DossierPositionRepository(axios);
    },
    get dossierTeamRepository(): DossierTeamRepositoryInterface {
      return new DossierTeamRepository(axios);
    },
    get dossierMembershipRepository(): DossierMembershipRepositoryInterface {
      return new DossierMembershipRepository(axios);
    },
    get dossierFeedbackRepository(): DossierFeedbackRepositoryInterface {
      return new DossierFeedbackRepository(axios);
    },
    get dossierFeedbackReviewRepository(): DossierFeedbackReviewRepositoryInterface {
      return new DossierFeedbackReviewRepository(axios);
    },
    get ticketRepositoryV2(): TicketRepositoryInterfaceV2 {
      return new TicketRepositoryV2(axios);
    },
    get websiteRepository(): WebsiteRepositoryInterface {
      return new WebsiteRepository(axios);
    },
    get redisCacheRepository(): RedisCacheRepositoryInterface {
      return new RedisCacheRepository(axios);
    },
    get smsRepository(): SMSRepositoryInterface {
      return new SMSRepository(axios);
    },
    get websiteGroupRepository(): WebsiteGroupRepositoryInterface {
      return new WebsiteGroupRepository(axios);
    },
    get mailboxRepository(): MailboxRepositoryInterface {
      return new MailboxRepository(axios);
    },
    get internalTicketsRepository(): InternalTicketsRepositoryInterface {
      return new InternalTicketsRepository(axios);
    },
    get ftpUserRepository(): FtpUserRepositoryInterface {
      return new FtpUserRepository(axios);
    },
    get websiteLogRepository(): WebsiteLogRepositoryInterface {
      return new WebsiteLogRepository(axios);
    },
    get websiteStagingRepository(): WebsiteStagingRepositoryInterface {
      return new WebsiteStagingRepository(axios);
    },
    get wpCliRepository(): WPCliRepositoryInterface {
      return new WPCliRepository(axios);
    },

    get actionLogRepository(): ActionLogRepositoryInterface {
      return new ActionLogRepository(axios);
    },

    get backupServerRepository(): BackupServerRepositoryInterface {
      return new BackupServerRepository(axios);
    },

    get backupRepository(): BackupRepositoryInterface {
      return new BackupRepository(axios);
    },

    get restoreTaskRepository(): RestoreTaskRepositoryInterface {
      return new RestoreTaskRepository(axios);
    },

    get backupRepoRepository(): BackupRepoRepositoryInterface {
      return new BackupRepoRepository(axios);
    },

    get backupScheduleRepository(): BackupScheduleRepositoryInterface {
      return new BackupScheduleRepository(axios);
    },

    get taskScheduleRepository(): TaskScheduleRepositoryInterface {
      return new TaskScheduleRepository(axios);
    },

    get taskRepository(): TaskRepositoryInterface {
      return new TaskRepository(axios);
    },

    get backupTaskRepository(): BackupTaskRepositoryInterface {
      return new BackupTaskRepository(axios);
    },

    get backupLogRepository(): BackupLogRepositoryInterface {
      return new BackupLogRepository(axios);
    },

    get configResetRepository(): ConfigResetRepositoryInterface {
      return new ConfigResetRepository(axios);
    },

    get forgetServerRepository(): ForgetServerRepositoryInterface {
      return new ForgetServerRepository(axios);
    },
    get repoLocksRepository(): RepoLocksRepositoryInterface {
      return new RepoLocksRepository(axios);
    },
    get websiteMigrationsRepository(): WebsiteMigrationsRepositoryInterface {
      return new WebsiteMigrationsRepository(axios);
    },
    get planRepository(): PlanRepositoryInterface {
      return new PlanRepository(axios);
    },
    get usageRepository(): UsageRepositoryInterface {
      return new UsageRepository(axios);
    }
  };
}
